import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import SlideToggle from '../../../../../common/components/ui/toggleSwitch/SlideToggle';
import { toggleVehicleBlockStatus } from '../../../../../common/services/vehicles.api';
import { useToastContext } from '../../../../../common/components/ui/toast/toast.context';
import Permission from '../../../../../common/components/auth/Permission';

interface VehicleBlockToggleProps {
  vehicleId: string;
  initialVehicleBlockStatus: boolean;
  onStatusChange: (blocked: boolean, blockedDate: Date) => void;
}

const VehicleBlockToggle: React.FC<VehicleBlockToggleProps> = ({ vehicleId, initialVehicleBlockStatus, onStatusChange }) => {
  const [vehicleBlock, setVehicleBlock] = useState(initialVehicleBlockStatus);
  const { notifySuccess, notifyError } = useToastContext();
  const changeVehicleBlockStatus = async (vehicleBlockStatus: boolean) => {
    const result = await toggleVehicleBlockStatus(vehicleId, {
      velotrackSettings: {
        blocked: vehicleBlockStatus,
        blockedDate: new Date()
      }
    });
    if (result.ok) {
      setVehicleBlock(vehicleBlockStatus);
      onStatusChange(vehicleBlockStatus, new Date());
      notifySuccess(`Veículo ${vehicleBlockStatus ? "bloqueado" : "desbloqueado"}!`);
    } else {
      notifyError("Não foi possível alterar o status de bloqueio!");
    }
  };

  useEffect(() => {
    setVehicleBlock(initialVehicleBlockStatus);
  }, [initialVehicleBlockStatus])

  return (
    <Permission permission="change:vehicle-block-status">
      <div className="p-2 flex items-center justify-between bg-white/50 rounded-br-md border w-full border-gray/50">
        <label className="font-semibold text-[14px]">Situação do veículo: </label>
        <div className="pb-3 mt-2" style={{ display: 'flex', alignItems: 'center' }}>
          <SlideToggle
            name="isCheckedLockOrUnlock"
            color="redPrimary"
            initialState={vehicleBlock}
            onToggle={() => changeVehicleBlockStatus(!vehicleBlock)}
          />
          <span style={{
            marginLeft: '10px',
            color: `${vehicleBlock ? "redPrimary" : "black"}`,
            fontWeight: 'bold'
          }}>
            {vehicleBlock ? "Bloqueado" : "Desbloqueado"} {vehicleBlock ?
              ` - ${format(new Date(), "dd/MM/yyyy HH:mm")}` :
              ""
            }
          </span>
        </div>
      </div>
    </Permission>
  );
};

export default VehicleBlockToggle;
